import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function HomePage() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // Google Ads conversion tracking - Llamar con un clic
  const trackCallConversion = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const url = 'tel:091509830';
    if (typeof window !== 'undefined' && (window as any).gtag_report_conversion) {
      (window as any).gtag_report_conversion(url);
    } else {
      window.location.href = url;
    }
  };

  // Google Ads conversion tracking - WhatsApp / Compra
  const trackConversion = () => {
    if (typeof window !== 'undefined' && (window as any).gtag) {
      (window as any).gtag('event', 'conversion', {
        send_to: 'AW-10840860821/YbvpCO7O64IcEJXRqbEo',
        value: 1.0,
        currency: 'USD',
        transaction_id: '',
      });
    }
  };

  // Handle scroll effect for navbar
  if (typeof window !== 'undefined') {
    window.addEventListener('scroll', () => {
      setScrolled(window.scrollY > 50);
    });
  }

  return (
    <div className="min-h-screen bg-white font-['Inter']">
      {/* Top Contact Bar */}
      <div className="fixed top-0 left-0 right-0 z-[60] bg-gray-900 py-2">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-center justify-center gap-3 md:gap-6 flex-wrap">
            <a 
              href="tel:091509830" 
              onClick={(e) => { e.preventDefault(); (window as any).gtag_report_conversion('tel:091509830'); }}
              className="flex items-center gap-2 text-white hover:text-yellow-400 transition-colors"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-phone-fill text-yellow-400 text-lg"></i>
              </div>
              <span className="font-bold text-sm md:text-base">091509830</span>
            </a>
            <div className="hidden md:block w-px h-5 bg-gray-600"></div>
            <a 
              href="https://wa.me/59891509830"
              target="_blank"
              rel="noopener noreferrer"
              onClick={trackConversion}
              className="bg-green-500 hover:bg-green-400 text-white px-4 py-1.5 rounded-full font-bold text-sm flex items-center gap-2 transition-all whitespace-nowrap shadow-lg"
            >
              <i className="ri-whatsapp-fill text-lg"></i>
              <span>Escribinos por WhatsApp</span>
            </a>
            <div className="hidden md:flex items-center gap-2 text-gray-300 text-sm">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-time-fill text-yellow-400"></i>
              </div>
              <span>24/7 Disponible</span>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className={`fixed w-full z-50 transition-all duration-300 top-[40px] ${scrolled ? 'bg-white shadow-lg' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <span className="text-2xl font-black text-yellow-500">Cerrajería 24/7</span>
            </div>
            
            <div className="hidden md:flex items-center gap-8">
              <a href="#servicios" className={`text-sm font-medium transition-colors ${scrolled ? 'text-gray-700 hover:text-yellow-600' : 'text-white hover:text-yellow-400'}`}>
                Servicios
              </a>
              <a href="#nosotros" className={`text-sm font-medium transition-colors ${scrolled ? 'text-gray-700 hover:text-yellow-600' : 'text-white hover:text-yellow-400'}`}>
                Nosotros
              </a>
              <a href="#testimonios" className={`text-sm font-medium transition-colors ${scrolled ? 'text-gray-700 hover:text-yellow-600' : 'text-white hover:text-yellow-400'}`}>
                Testimonios
              </a>
              <a href="#faq" className={`text-sm font-medium transition-colors ${scrolled ? 'text-gray-700 hover:text-yellow-600' : 'text-white hover:text-yellow-400'}`}>
                FAQ
              </a>
              <a 
                href="tel:091509830" 
                onClick={(e) => { e.preventDefault(); (window as any).gtag_report_conversion('tel:091509830'); }}
                className="bg-yellow-500 text-black px-10 py-5 rounded-full font-black text-2xl hover:bg-yellow-400 transition-all whitespace-nowrap flex items-center gap-3 shadow-2xl animate-pulse"
              >
                <i className="ri-phone-fill text-3xl"></i>
                091509830
              </a>
            </div>

            <button 
              className="md:hidden text-white"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              <i className={`text-2xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} ${scrolled ? 'text-gray-900' : 'text-white'}`}></i>
            </button>
          </div>

          {/* Mobile Menu */}
          {mobileMenuOpen && (
            <div className="md:hidden mt-4 pb-4 bg-white rounded-lg shadow-xl">
              <div className="flex flex-col gap-4 p-4">
                <a href="#servicios" className="text-gray-700 font-medium hover:text-yellow-600">Servicios</a>
                <a href="#nosotros" className="text-gray-700 font-medium hover:text-yellow-600">Nosotros</a>
                <a href="#testimonios" className="text-gray-700 font-medium hover:text-yellow-600">Testimonios</a>
                <a href="#faq" className="text-gray-700 font-medium hover:text-yellow-600">FAQ</a>
                <a 
                  href="tel:091509830" 
                  onClick={(e) => { e.preventDefault(); (window as any).gtag_report_conversion('tel:091509830'); }}
                  className="bg-yellow-500 text-black px-6 py-4 rounded-full font-black text-xl text-center whitespace-nowrap animate-pulse flex items-center justify-center gap-2"
                >
                  <i className="ri-phone-fill text-2xl"></i> 
                  <span>091509830</span>
                </a>
              </div>
            </div>
          )}
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center overflow-hidden pt-[40px]">
        <div className="absolute inset-0">
          <img 
            src="https://public.readdy.ai/ai/img_res/6bf84babbe9d9e22c8db54da6bbfc5a9.jpg"
            alt="Cerrajería Profesional"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/40"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 w-full">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center gap-2 bg-red-600 text-white px-4 py-2 rounded-full mb-6 animate-pulse">
                <i className="ri-alarm-warning-fill"></i>
                <span className="font-bold text-sm whitespace-nowrap">DISPONIBLE 24/7</span>
              </div>

              <h1 className="text-5xl md:text-7xl font-black text-white leading-tight mb-6">
                Cerrajería de Urgencia
                <br />
                <span className="text-yellow-400">Hogar & Automotriz</span>
              </h1>

              <p className="text-xl text-gray-200 mb-8 leading-relaxed">
                Servicio profesional certificado. Llegamos en 20 minutos o menos. Sin cargos ocultos.
              </p>

              <div className="flex flex-wrap gap-4 mb-8">
                <a 
                  href="tel:091509830"
                  onClick={(e) => { e.preventDefault(); (window as any).gtag_report_conversion('tel:091509830'); }}
                  className="bg-yellow-500 text-black px-8 md:px-10 py-4 md:py-5 rounded-full font-black text-xl md:text-2xl hover:bg-yellow-400 transition-all shadow-2xl flex items-center gap-2 md:gap-3 whitespace-nowrap animate-pulse"
                >
                  <i className="ri-phone-fill text-2xl md:text-3xl"></i>
                  <span>LLAMAR AHORA</span>
                </a>
                <a 
                  href="https://wa.me/59891509830"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={trackConversion}
                  className="border-2 border-white text-white px-6 md:px-8 py-4 rounded-full font-bold text-base md:text-lg hover:bg-white hover:text-black transition-all flex items-center gap-2 md:gap-3 whitespace-nowrap"
                >
                  <i className="ri-whatsapp-fill text-lg md:text-xl text-green-400"></i>
                  <span>WhatsApp</span>
                </a>
              </div>

              {/* Phone Number Display */}
              <div className="bg-black/50 backdrop-blur-sm p-6 md:p-8 rounded-3xl border-4 border-yellow-500 mb-12">
                <div className="text-center">
                  <div className="text-yellow-400 text-base md:text-lg font-bold mb-2">LLÁMANOS AHORA</div>
                  <a 
                    href="tel:091509830" 
                    onClick={(e) => { e.preventDefault(); (window as any).gtag_report_conversion('tel:091509830'); }}
                    className="text-white text-4xl md:text-6xl font-black hover:text-yellow-400 transition-colors block"
                  >
                    091509830
                  </a>
                  <div className="text-gray-300 text-xs md:text-sm mt-2">Disponible 24 horas</div>
                </div>
              </div>

              <div className="grid grid-cols-3 gap-4 md:gap-6">
                <div className="text-center">
                  <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center mx-auto mb-2">
                    <i className="ri-shield-check-fill text-3xl md:text-4xl text-yellow-400"></i>
                  </div>
                  <div className="text-2xl md:text-3xl font-black text-white">500+</div>
                  <div className="text-xs md:text-sm text-gray-300">Clientes</div>
                </div>
                <div className="text-center">
                  <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center mx-auto mb-2">
                    <i className="ri-star-fill text-3xl md:text-4xl text-yellow-400"></i>
                  </div>
                  <div className="text-2xl md:text-3xl font-black text-white">4.9</div>
                  <div className="text-xs md:text-sm text-gray-300">Calificación</div>
                </div>
                <div className="text-center">
                  <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center mx-auto mb-2">
                    <i className="ri-time-fill text-3xl md:text-4xl text-yellow-400"></i>
                  </div>
                  <div className="text-2xl md:text-3xl font-black text-white">20min</div>
                  <div className="text-xs md:text-sm text-gray-300">Respuesta</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="servicios" className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-4">
              Aperturas de Casas, Autos, Llaves Codificadas
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Soluciones profesionales para todas tus necesidades de cerrajería
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-gray-50 p-8 rounded-2xl hover:bg-white hover:shadow-xl transition-all cursor-pointer group">
              <div className="w-16 h-16 flex items-center justify-center mb-6">
                <i className="ri-home-lock-fill text-5xl text-gray-900 group-hover:text-yellow-500 transition-colors"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Cerrajería Residencial</h3>
              <ul className="space-y-3">
                <li className="flex items-start gap-2 text-gray-700">
                  <i className="ri-checkbox-circle-fill text-yellow-500 mt-1"></i>
                  <span className="text-sm">Apertura de puertas</span>
                </li>
                <li className="flex items-start gap-2 text-gray-700">
                  <i className="ri-checkbox-circle-fill text-yellow-500 mt-1"></i>
                  <span className="text-sm">Cambio de cerraduras</span>
                </li>
                <li className="flex items-start gap-2 text-gray-700">
                  <i className="ri-checkbox-circle-fill text-yellow-500 mt-1"></i>
                  <span className="text-sm">Llaves duplicadas</span>
                </li>
                <li className="flex items-start gap-2 text-gray-700">
                  <i className="ri-checkbox-circle-fill text-yellow-500 mt-1"></i>
                  <span className="text-sm">Cerraduras de seguridad</span>
                </li>
              </ul>
            </div>

            <div className="bg-gray-50 p-8 rounded-2xl hover:bg-white hover:shadow-xl transition-all cursor-pointer group">
              <div className="w-16 h-16 flex items-center justify-center mb-6">
                <i className="ri-car-fill text-5xl text-gray-900 group-hover:text-yellow-500 transition-colors"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Cerrajería Automotriz</h3>
              <ul className="space-y-3">
                <li className="flex items-start gap-2 text-gray-700">
                  <i className="ri-checkbox-circle-fill text-yellow-500 mt-1"></i>
                  <span className="text-sm">Apertura de vehículos</span>
                </li>
                <li className="flex items-start gap-2 text-gray-700">
                  <i className="ri-checkbox-circle-fill text-yellow-500 mt-1"></i>
                  <span className="text-sm">Llaves codificadas</span>
                </li>
                <li className="flex items-start gap-2 text-gray-700">
                  <i className="ri-checkbox-circle-fill text-yellow-500 mt-1"></i>
                  <span className="text-sm">Programación de llaves</span>
                </li>
                <li className="flex items-start gap-2 text-gray-700">
                  <i className="ri-checkbox-circle-fill text-yellow-500 mt-1"></i>
                  <span className="text-sm">Reparación de cerraduras</span>
                </li>
              </ul>
            </div>

            <div className="bg-gray-50 p-8 rounded-2xl hover:bg-white hover:shadow-xl transition-all cursor-pointer group">
              <div className="w-16 h-16 flex items-center justify-center mb-6">
                <i className="ri-building-fill text-5xl text-gray-900 group-hover:text-yellow-500 transition-colors"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Cerrajería Comercial</h3>
              <ul className="space-y-3">
                <li className="flex items-start gap-2 text-gray-700">
                  <i className="ri-checkbox-circle-fill text-yellow-500 mt-1"></i>
                  <span className="text-sm">Sistemas maestros</span>
                </li>
                <li className="flex items-start gap-2 text-gray-700">
                  <i className="ri-checkbox-circle-fill text-yellow-500 mt-1"></i>
                  <span className="text-sm">Control de acceso</span>
                </li>
                <li className="flex items-start gap-2 text-gray-700">
                  <i className="ri-checkbox-circle-fill text-yellow-500 mt-1"></i>
                  <span className="text-sm">Cajas fuertes</span>
                </li>
                <li className="flex items-start gap-2 text-gray-700">
                  <i className="ri-checkbox-circle-fill text-yellow-500 mt-1"></i>
                  <span className="text-sm">Cerraduras electrónicas</span>
                </li>
              </ul>
            </div>

            <div className="bg-gray-50 p-8 rounded-2xl hover:bg-white hover:shadow-xl transition-all cursor-pointer group">
              <div className="w-16 h-16 flex items-center justify-center mb-6">
                <i className="ri-24-hours-fill text-5xl text-gray-900 group-hover:text-yellow-500 transition-colors"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Emergencias 24/7</h3>
              <ul className="space-y-3">
                <li className="flex items-start gap-2 text-gray-700">
                  <i className="ri-checkbox-circle-fill text-yellow-500 mt-1"></i>
                  <span className="text-sm">Servicio inmediato</span>
                </li>
                <li className="flex items-start gap-2 text-gray-700">
                  <i className="ri-checkbox-circle-fill text-yellow-500 mt-1"></i>
                  <span className="text-sm">Disponibilidad total</span>
                </li>
                <li className="flex items-start gap-2 text-gray-700">
                  <i className="ri-checkbox-circle-fill text-yellow-500 mt-1"></i>
                  <span className="text-sm">Respuesta rápida</span>
                </li>
                <li className="flex items-start gap-2 text-gray-700">
                  <i className="ri-checkbox-circle-fill text-yellow-500 mt-1"></i>
                  <span className="text-sm">Precios transparentes</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="nosotros" className="py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-6">
                Nosotros
              </h2>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                Somos una empresa de cerrajería con más de 15 años de experiencia en el mercado, especializada en servicios de emergencia para hogares y vehículos. Nuestro equipo de técnicos certificados está disponible las 24 horas del día, los 7 días de la semana.
              </p>
              <p className="text-lg text-gray-700 mb-8 leading-relaxed">
                Nos caracterizamos por nuestra rapidez, profesionalismo y precios justos. Cada trabajo está respaldado por nuestra garantía de satisfacción y utilizamos únicamente herramientas y productos de la más alta calidad.
              </p>
              <div className="grid grid-cols-2 gap-6">
                <div className="bg-white p-6 rounded-xl shadow-md">
                  <div className="text-4xl font-black text-yellow-500 mb-2">15+</div>
                  <div className="text-sm font-medium text-gray-700">Años de Experiencia</div>
                </div>
                <div className="bg-white p-6 rounded-xl shadow-md">
                  <div className="text-4xl font-black text-yellow-500 mb-2">100%</div>
                  <div className="text-sm font-medium text-gray-700">Certificados</div>
                </div>
              </div>
            </div>
            <div className="relative">
              <img 
                src="https://readdy.ai/api/search-image?query=Young%20professional%20automotive%20locksmith%20technician%20in%20his%20twenties%20wearing%20black%20work%20uniform%20using%20professional%20OBD2%20diagnostic%20scanner%20tool%20connected%20to%20car%20computer%20system%2C%20focused%20on%20electronic%20device%20screen%20while%20programming%20transponder%20key%2C%20bright%20workshop%20lighting%20showing%20modern%20automotive%20key%20coding%20technology%2C%20detailed%20view%20of%20hands%20holding%20diagnostic%20scanner%20equipment%20with%20vehicle%20dashboard%20visible%20in%20background%2C%20clean%20professional%20automotive%20locksmith%20service%20demonstrating%20advanced%20vehicle%20security%20programming%20expertise&width=800&height=1000&seq=young-locksmith-scanner-tech&orientation=portrait"
                alt="Técnico de Cerrajería Automotriz"
                className="w-full h-[600px] object-cover rounded-2xl shadow-2xl"
              />
              <div className="absolute -bottom-6 -right-6 bg-yellow-500 text-black p-6 rounded-xl shadow-xl">
                <div className="text-3xl font-black">24/7</div>
                <div className="text-sm font-bold whitespace-nowrap">Siempre Disponibles</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section id="testimonios" className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-4">
              Testimonios
            </h2>
            <p className="text-lg text-gray-600">Lo que dicen nuestros clientes</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-gray-900 p-8 rounded-3xl relative">
              <div className="w-16 h-16 flex items-center justify-center mb-4">
                <i className="ri-double-quotes-l text-5xl text-yellow-400"></i>
              </div>
              <p className="text-white text-lg mb-6 leading-relaxed">
                Excelente servicio. Me quedé afuera de mi casa a las 2 AM y llegaron en 15 minutos. Muy profesionales y precio justo.
              </p>
              <div className="flex items-center gap-2 mb-2">
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
              </div>
              <div className="font-bold text-white">María González</div>
              <div className="text-sm text-gray-400">Montevideo</div>
            </div>

            <div className="bg-gray-900 p-8 rounded-3xl relative">
              <div className="w-16 h-16 flex items-center justify-center mb-4">
                <i className="ri-double-quotes-l text-5xl text-yellow-400"></i>
              </div>
              <p className="text-white text-lg mb-6 leading-relaxed">
                Perdí las llaves de mi auto y me hicieron una llave codificada en el momento. Servicio rápido y eficiente. Totalmente recomendados.
              </p>
              <div className="flex items-center gap-2 mb-2">
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
              </div>
              <div className="font-bold text-white">Carlos Rodríguez</div>
              <div className="text-sm text-gray-400">Maldonado</div>
            </div>

            <div className="bg-gray-900 p-8 rounded-3xl relative">
              <div className="w-16 h-16 flex items-center justify-center mb-4">
                <i className="ri-double-quotes-l text-5xl text-yellow-400"></i>
              </div>
              <p className="text-white text-lg mb-6 leading-relaxed">
                Muy confiables. Cambiaron todas las cerraduras de mi negocio y quedó perfecto. Precios competitivos y trabajo de calidad.
              </p>
              <div className="flex items-center gap-2 mb-2">
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
              </div>
              <div className="font-bold text-white">Ana Martínez</div>
              <div className="text-sm text-gray-400">Canelones</div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-gradient-to-r from-gray-900 to-gray-800">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-block bg-red-600 text-white px-4 py-2 rounded-full text-sm font-bold mb-6 whitespace-nowrap">
                EMERGENCIA
              </div>
              <h2 className="text-4xl md:text-6xl font-black text-white mb-6 leading-tight">
                ¿Quedaste Fuera de Tu Casa?
              </h2>
              <p className="text-xl text-gray-300 mb-8">
                No te preocupes, estamos aquí para ayudarte. Respuesta inmediata las 24 horas.
              </p>
            </div>
            <div className="bg-yellow-500 p-12 rounded-3xl">
              <h3 className="text-3xl font-black text-black mb-4">
                Respuesta Inmediata
              </h3>
              <p className="text-gray-800 mb-8 text-lg">
                Nuestros técnicos certificados están listos para ayudarte. Servicio garantizado con precios transparentes.
              </p>
              <a 
                href="tel:091509830"
                onClick={(e) => { e.preventDefault(); (window as any).gtag_report_conversion('tel:091509830'); }}
                className="bg-black text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-800 transition-all inline-flex items-center gap-3 whitespace-nowrap"
              >
                Llamar Ahora: 091509830
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-24 bg-gray-900">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <div className="w-16 h-16 md:w-20 md:h-20 flex items-center justify-center mx-auto mb-6">
            <i className="ri-phone-fill text-5xl md:text-6xl text-yellow-400"></i>
          </div>
          <h2 className="text-5xl md:text-7xl lg:text-8xl font-black text-white mb-6 break-all">
            091509830
          </h2>
          <p className="text-lg md:text-2xl text-gray-300 mb-8 max-w-2xl mx-auto font-bold">
            Llámanos ahora para servicio inmediato. Disponibles 24 horas, 7 días a la semana.
          </p>
          <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-4">
            <a 
              href="tel:091509830"
              onClick={(e) => { e.preventDefault(); (window as any).gtag_report_conversion('tel:091509830'); }}
              className="bg-yellow-500 text-black px-8 md:px-12 py-5 md:py-6 rounded-full font-black text-xl md:text-2xl hover:bg-yellow-400 transition-all inline-flex items-center justify-center gap-2 md:gap-3 whitespace-nowrap shadow-2xl animate-pulse"
            >
              <i className="ri-phone-fill text-2xl md:text-3xl"></i>
              <span>Llamar Ahora</span>
            </a>
            <a 
              href="https://wa.me/59891509830"
              target="_blank"
              rel="noopener noreferrer"
              onClick={trackConversion}
              className="bg-green-500 text-white px-8 md:px-12 py-5 md:py-6 rounded-full font-black text-xl md:text-2xl hover:bg-green-400 transition-all inline-flex items-center justify-center gap-2 md:gap-3 whitespace-nowrap shadow-2xl"
            >
              <i className="ri-whatsapp-fill text-2xl md:text-3xl"></i>
              <span>WhatsApp</span>
            </a>
          </div>
        </div>
      </section>

      {/* Coverage Map Section */}
      <section className="py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 bg-yellow-100 text-yellow-800 px-4 py-2 rounded-full mb-4">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-map-pin-2-fill text-yellow-600"></i>
              </div>
              <span className="font-bold text-sm">ZONA DE COBERTURA</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-4">
              Cubrimos Todo Montevideo
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Nuestros técnicos están distribuidos estratégicamente en toda la ciudad para llegar a vos en menos de 20 minutos
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 items-start">
            {/* Coverage zones list */}
            <div className="bg-white rounded-2xl shadow-lg p-8">
              <h3 className="text-xl font-black text-gray-900 mb-6 flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center bg-yellow-500 rounded-full">
                  <i className="ri-map-pin-fill text-black text-sm"></i>
                </div>
                Zonas que Cubrimos
              </h3>
              <ul className="space-y-3">
                {[
                  'Centro y Ciudad Vieja',
                  'Pocitos y Punta Carretas',
                  'Carrasco y Buceo',
                  'Malvín y Parque Batlle',
                  'Tres Cruces y Cordón',
                  'Aguada y Goes',
                  'Sayago y Paso de la Arena',
                  'Maroñas y Manga',
                  'Cerro y La Teja',
                  'Prado y Belvedere',
                  'Peñarol y Colón',
                  'Zona Metropolitana',
                ].map((zone) => (
                  <li key={zone} className="flex items-center gap-3 text-gray-700">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                      <i className="ri-checkbox-circle-fill text-yellow-500 text-lg"></i>
                    </div>
                    <span className="text-sm font-medium">{zone}</span>
                  </li>
                ))}
              </ul>
              <div className="mt-6 p-4 bg-yellow-50 rounded-xl border border-yellow-200">
                <p className="text-sm text-yellow-800 font-medium text-center">
                  ¿No ves tu zona? ¡Llamanos igual! También cubrimos áreas cercanas.
                </p>
              </div>
            </div>

            {/* Google Maps Embed */}
            <div className="md:col-span-2">
              <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
                <div className="w-full h-[500px]">
                  <iframe
                    title="Área de cobertura Cerrajería Montevideo"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d104527.05791088!2d-56.2731!3d-34.9011!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x959f802b6753b221%3A0x3d3f8e0b8e8e8e8e!2sMontevideo%2C%20Uruguay!5e0!3m2!1ses!2suy!4v1700000000000!5m2!1ses!2suy"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
                <div className="p-6 bg-gray-900">
                  <div className="flex flex-wrap items-center justify-between gap-4">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 flex items-center justify-center bg-yellow-500 rounded-full">
                        <i className="ri-map-pin-fill text-black text-lg"></i>
                      </div>
                      <div>
                        <div className="text-white font-bold">Montevideo, Uruguay</div>
                        <div className="text-gray-400 text-sm">Cobertura en toda la ciudad</div>
                      </div>
                    </div>
                    <div className="flex items-center gap-6">
                      <div className="text-center">
                        <div className="text-yellow-400 font-black text-2xl">20min</div>
                        <div className="text-gray-400 text-xs">Tiempo máximo</div>
                      </div>
                      <div className="text-center">
                        <div className="text-yellow-400 font-black text-2xl">24/7</div>
                        <div className="text-gray-400 text-xs">Disponibilidad</div>
                      </div>
                      <div className="text-center">
                        <div className="text-yellow-400 font-black text-2xl">100%</div>
                        <div className="text-gray-400 text-xs">Cobertura</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section id="faq" className="py-24 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-4">
              Preguntas Frecuentes
            </h2>
            <p className="text-lg text-gray-600">Respuestas a las dudas más comunes</p>
          </div>

          <div className="space-y-6">
            <details className="bg-gray-50 p-6 rounded-xl group">
              <summary className="font-bold text-lg text-gray-900 cursor-pointer flex items-center justify-between">
                ¿Cuánto tiempo tardan en llegar?
                <i className="ri-arrow-down-s-line text-2xl group-open:rotate-180 transition-transform"></i>
              </summary>
              <p className="mt-4 text-gray-700 leading-relaxed">
                Nuestro tiempo promedio de respuesta es de 20 minutos o menos, dependiendo de tu ubicación. Contamos con unidades móviles estratégicamente ubicadas para brindarte el servicio más rápido posible.
              </p>
            </details>

            <details className="bg-gray-50 p-6 rounded-xl group">
              <summary className="font-bold text-lg text-gray-900 cursor-pointer flex items-center justify-between">
                ¿Cuánto cuesta el servicio?
                <i className="ri-arrow-down-s-line text-2xl group-open:rotate-180 transition-transform"></i>
              </summary>
              <p className="mt-4 text-gray-700 leading-relaxed">
                Los precios varían según el tipo de servicio requerido. Siempre proporcionamos un presupuesto claro antes de comenzar el trabajo. No hay cargos ocultos y aceptamos múltiples formas de pago.
              </p>
            </details>

            <details className="bg-gray-50 p-6 rounded-xl group">
              <summary className="font-bold text-lg text-gray-900 cursor-pointer flex items-center justify-between">
                ¿Están disponibles los fines de semana?
                <i className="ri-arrow-down-s-line text-2xl group-open:rotate-180 transition-transform"></i>
              </summary>
              <p className="mt-4 text-gray-700 leading-relaxed">
                Sí, estamos disponibles las 24 horas del día, los 7 días de la semana, incluyendo fines de semana y feriados. Las emergencias no tienen horario y nosotros tampoco.
              </p>
            </details>

            <details className="bg-gray-50 p-6 rounded-xl group">
              <summary className="font-bold text-lg text-gray-900 cursor-pointer flex items-center justify-between">
                ¿Pueden hacer llaves codificadas para autos?
                <i className="ri-arrow-down-s-line text-2xl group-open:rotate-180 transition-transform"></i>
              </summary>
              <p className="mt-4 text-gray-700 leading-relaxed">
                Sí, contamos con la tecnología y experiencia necesaria para programar llaves codificadas para la mayoría de las marcas y modelos de vehículos. El servicio se realiza en el lugar.
              </p>
            </details>

            <details className="bg-gray-50 p-6 rounded-xl group">
              <summary className="font-bold text-lg text-gray-900 cursor-pointer flex items-center justify-between">
                ¿Ofrecen garantía en sus trabajos?
                <i className="ri-arrow-down-s-line text-2xl group-open:rotate-180 transition-transform"></i>
              </summary>
              <p className="mt-4 text-gray-700 leading-relaxed">
                Todos nuestros trabajos están respaldados por una garantía de satisfacción. Si tienes algún problema con el servicio realizado, lo solucionamos sin costo adicional.
              </p>
            </details>

            <details className="bg-gray-50 p-6 rounded-xl group">
              <summary className="font-bold text-lg text-gray-900 cursor-pointer flex items-center justify-between">
                ¿Necesito identificación para el servicio?
                <i className="ri-arrow-down-s-line text-2xl group-open:rotate-180 transition-transform"></i>
              </summary>
              <p className="mt-4 text-gray-700 leading-relaxed">
                Sí, por seguridad solicitamos identificación y comprobante de domicilio o propiedad del vehículo antes de realizar cualquier apertura. Esto protege tanto a nuestros clientes como a nosotros.
              </p>
            </details>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gradient-to-br from-teal-900 to-teal-800 text-white py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-4 gap-12 mb-12">
            <div>
              <span className="text-2xl font-black text-yellow-500">Cerrajería 24/7</span>
              <p className="text-gray-300 text-sm leading-relaxed">
                Servicio profesional de cerrajería disponible 24/7 para emergencias de hogar y automotriz.
              </p>
            </div>

            <div>
              <h4 className="font-bold text-lg mb-4">Servicios</h4>
              <ul className="space-y-2 text-gray-300 text-sm">
                <li><a href="#servicios" className="hover:text-yellow-400 transition-colors">Cerrajería Residencial</a></li>
                <li><a href="#servicios" className="hover:text-yellow-400 transition-colors">Cerrajería Automotriz</a></li>
                <li><a href="#servicios" className="hover:text-yellow-400 transition-colors">Cerrajería Comercial</a></li>
              </ul>
            </div>

            <div>
              <h4 className="font-bold text-lg mb-4">Empresa</h4>
              <ul className="space-y-2 text-gray-300 text-sm">
                <li><a href="#nosotros" className="hover:text-yellow-400 transition-colors">Nosotros</a></li>
                <li><a href="#testimonios" className="hover:text-yellow-400 transition-colors">Testimonios</a></li>
                <li><a href="#faq" className="hover:text-yellow-400 transition-colors">Preguntas Frecuentes</a></li>
              </ul>
            </div>

            <div>
              <h4 className="font-bold text-lg mb-4">Contacto</h4>
              <ul className="space-y-3 text-gray-300 text-sm">
                <li className="flex items-center gap-2">
                  <i className="ri-phone-fill text-yellow-400"></i>
                  <a 
                    href="tel:091509830" 
                    onClick={(e) => { e.preventDefault(); (window as any).gtag_report_conversion('tel:091509830'); }}
                    className="hover:text-yellow-400 transition-colors"
                  >
                    091509830
                  </a>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-whatsapp-fill text-yellow-400"></i>
                  <a href="https://wa.me/59891509830" className="hover:text-yellow-400 transition-colors">WhatsApp</a>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-time-fill text-yellow-400"></i>
                  <span>24/7 Disponible</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-teal-700 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4">
              <div className="text-sm text-gray-300">
                © 2025 Cerrajería del Hogar y Automotor. Todos los derechos reservados.
              </div>
              <div className="flex items-center gap-6">
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-lg hover:bg-white/10 transition-all">
                  <i className="ri-facebook-fill text-xl"></i>
                </a>
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-lg hover:bg-white/10 transition-all">
                  <i className="ri-instagram-fill text-xl"></i>
                </a>
                <a href="https://wa.me/59891509830" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-lg hover:bg-white/10 transition-all">
                  <i className="ri-whatsapp-fill text-xl"></i>
                </a>
              </div>
              <div className="text-sm text-gray-300">
                <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-yellow-400 transition-colors">
                  Powered by Readdy
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
